import accommodationType from 'app/entities/accommodation-type/accommodation-type.reducer';
import carOrVanAvailability from 'app/entities/car-or-van-availability/car-or-van-availability.reducer';
import generalHealth from 'app/entities/general-health/general-health.reducer';
import ageBySingleYearOfAge from 'app/entities/age-by-single-year-of-age/age-by-single-year-of-age.reducer';
import centralHeating from 'app/entities/central-heating/central-heating.reducer';
import disability from 'app/entities/disability/disability.reducer';
import economicActivityStatus from 'app/entities/economic-activity-status/economic-activity-status.reducer';
import ethnicGroup from 'app/entities/ethnic-group/ethnic-group.reducer';
import householdComposition from 'app/entities/household-composition/household-composition.reducer';
import householdSize from 'app/entities/household-size/household-size.reducer';
import industry from 'app/entities/industry/industry.reducer';
import methodOfTravelToWork from 'app/entities/method-of-travel-to-work/method-of-travel-to-work.reducer';
import occupation from 'app/entities/occupation/occupation.reducer';
import religion from 'app/entities/religion/religion.reducer';
import tenure from 'app/entities/tenure/tenure.reducer';
import numberOfRooms from 'app/entities/number-of-rooms/number-of-rooms.reducer';
import numberOfBedrooms from 'app/entities/number-of-bedrooms/number-of-bedrooms.reducer';
import sex from 'app/entities/sex/sex.reducer';
import countryOfBirth from 'app/entities/country-of-birth/country-of-birth.reducer';
import highestLevelOfQualification from 'app/entities/highest-level-of-qualification/highest-level-of-qualification.reducer';
import provisionOfUnpaidCare from 'app/entities/provision-of-unpaid-care/provision-of-unpaid-care.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  accommodationType,
  carOrVanAvailability,
  generalHealth,
  ageBySingleYearOfAge,
  centralHeating,
  disability,
  economicActivityStatus,
  ethnicGroup,
  householdComposition,
  householdSize,
  industry,
  methodOfTravelToWork,
  occupation,
  religion,
  tenure,
  numberOfRooms,
  numberOfBedrooms,
  sex,
  countryOfBirth,
  highestLevelOfQualification,
  provisionOfUnpaidCare,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
